<template>
    <div>
        <treeselect
            multiple
            v-model="model"
            :name="name"
            :options="options"
            noResultsText="Nichts gefunden"
            :flat="true"
            :placeholder="placeholder"
        ></treeselect>
    </div>
</template>

<script>
import treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
        components: { treeselect },

        props: {
            options: Array,
            name: String,
            value: Array,
            valueConsistsOf: String,
            placeholder: {
                required: false,
                type: String,
                default: '',
            },
        },

        data() {
            return {
                model: null,
                timeBlocks : [],
            }
        },

        mounted() {
          this.model = this.value ? this.value : null;
        },

      watch: {
        model(newVal) {
          window.dispatchEvent(new CustomEvent('cost-carriers-changed', {
            detail: {selectedIds: newVal || []}
          }));
        }
        }
    }
</script>

<style scoped>
    /* make the placeholder black so it matches other selects */
    .vue-treeselect__placeholder {
        color: black;
    }

    .vue-treeselect--focused .vue-treeselect__placeholder {
        color: #BDBDBD;
    }
</style>